module.exports = __webpack_public_path__ + "img/07-d872cd.png";